import React, { useEffect } from 'react';
import config from "../config";

import favicon from "../img/v1/favicon/favicon.ico"
import favicon192 from "../img/v1/favicon/logo192.png"
import faviconV2 from "../img/v2/favicon/favicon.ico"
import favicon192V2 from "../img/v1/favicon/logo192.png"
import faviconV3 from "../img/v3/favicon/favicon.ico"
import favicon192V3 from "../img/v3/favicon/logo192.png"

function Favicon() {

    useEffect(() => {
        removeFaviconTag();

        var link = document.createElement('link');
        link.type = 'image/png';
        link.rel = 'icon';
        link.href = config.version === "v2" ? faviconV2 : config.version === "v3" ? faviconV3 : favicon;

        document.getElementsByTagName('head')[0].appendChild(link);

        var link192 = document.createElement('link');
        link192.type = 'image/png';
        link192.rel = 'apple-touch-icon';
        link192.href = config.version === "v2" ? favicon192V2 : config.version === "v3" ? favicon192V3 : favicon192;

        document.getElementsByTagName('head')[0].appendChild(link192);
    })

    function removeFaviconTag() {
        var links = Array.prototype.slice.call(document.getElementsByTagName('link'), 0);
        var head = document.getElementsByTagName('head')[0];

        for (var i = 0, l = links.length; i < l; i++) {
            if (links[i].getAttribute('rel') === 'icon' || links[i].getAttribute('rel') === "apple-touch-icon") {
                head.removeChild(links[i]);
            }
        }
    };

    return (<></>);
}

export default Favicon;